import ClickableIcon from '@/components/ClickableIcon'
import { View } from '@/components/Icons'

import messages from './messages'

export default ({ intl, onView }: any) => [
  {
    property: 'displayName',
    header: { label: intl.formatMessage(messages.groupName), sortable: true },
    cell: { props: { className: 'group-list__column group-list__column--display-name' } }
  },
  {
    property: 'memberCount',
    header: { label: intl.formatMessage(messages.userCount), sortable: true },
    cell: { props: { className: 'group-list__column group-list__column--display-name' } }
  },
  {
    property: 'id',
    header: { label: intl.formatMessage(messages.userList) },
    cell: {
      formatters: [(groupId: any) => <ClickableIcon callback={onView} parameter={groupId} render={View} />],
      props: { className: 'group-list__column group-list__column--edit text-center' }
    }
  }
]
